import styled from 'styled-components';

import CuripodAgentSvg from '../../../../assets/icons/CuripodAgentSvg';
import theme from '../../../../assets/theme';
import { IconWrapper } from '../../../_atoms/IconWrapper';

export function CuripodChatAvatar() {
  return (
    <AgentBranding>
      <IconWrapper height="16px" width="16px" style={{ marginBottom: 2 }}>
        <CuripodAgentSvg />
      </IconWrapper>
      <span
        style={{
          fontWeight: 'bold',
          fontSize: 16,
          color: theme.colors.black,
          lineHeight: '16px',
        }}
      >
        Curipod
      </span>
    </AgentBranding>
  );
}

const AgentBranding = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 8px;
`;
